import React, { createContext, useContext, useState, useCallback } from 'react';

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentUpload, setCurrentUpload] = useState(null);

  const startUpload = useCallback((fileName) => {
    setIsUploading(true);
    setCurrentUpload(fileName);
    setUploadProgress(0);
  }, []);

  const updateProgress = useCallback((progress) => {
    setUploadProgress(progress);
  }, []);

  const endUpload = useCallback(() => {
    setIsUploading(false);
    setCurrentUpload(null);
    setUploadProgress(0);
  }, []);

  // Function to check if navigation should be blocked
  const shouldBlockNavigation = useCallback(() => {
    return isUploading;
  }, [isUploading]);

  return (
    <UploadContext.Provider value={{
      isUploading,
      uploadProgress,
      currentUpload,
      startUpload,
      updateProgress,
      endUpload,
      shouldBlockNavigation
    }}>
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => {
  const context = useContext(UploadContext);
  if (!context) {
    throw new Error('useUpload must be used within an UploadProvider');
  }
  return context;
};
